import { isMobileSafari, isIOS, isChrome } from 'mobile-device-detect';
var $ = require('jquery');
var bootstrap = require('bootstrap');
var bootbox = require('bootbox');

/* eslint-disable */
export default {
  onUpdate: registration => {
    const waitingServiceWorker = registration.waiting
    console.info('service worker on success update.');
    if(isChrome && !window.matchMedia('(display-mode: standalone)').matches){
    	console.log("testaaa");
    	
      bootbox.alert({
        message: "Se ha actualizado la versión de OronaLine",
        centerVertical: true,
        className: "zylk",
        callback: function(){ 
        	console.log("test1");
        	if (waitingServiceWorker) {
            	console.log("test2");
    	        waitingServiceWorker.addEventListener("statechange", event => {
                	console.log("test3");
    	          if (event.target.state === "activated") {
                  	console.log("test41");
    	            window.location.reload();
    	          }
    	        });
    	        waitingServiceWorker.postMessage({ type: "SKIP_WAITING" });
    	      }
        }
      });
    }

    if(isIOS && isMobileSafari){
        bootbox.alert({
            message: "Se ha actualizado la versión de OronaLine",
            centerVertical: true,
            className: "zylk",
            callback: function(){ 
            	if (waitingServiceWorker) {
        	        waitingServiceWorker.addEventListener("statechange", event => {
        	          if (event.target.state === "activated") {
        	            window.location.reload()
        	          }
        	        });
        	        waitingServiceWorker.postMessage({ type: "SKIP_WAITING" });
        	      }
            }
          });
    }

    if(isIOS && window.matchMedia('(display-mode: standalone)').matches){
        bootbox.alert({
            message: "Se ha actualizado la versión de OronaLine",
            centerVertical: true,
            className: "zylk",
            callback: function(){ 
            	if (waitingServiceWorker) {
        	        waitingServiceWorker.addEventListener("statechange", event => {
        	          if (event.target.state === "activated") {
        	            window.location.reload()
        	          }
        	        });
        	        waitingServiceWorker.postMessage({ type: "SKIP_WAITING" });
        	      }
            }
          });
    }
    
  }
}
      
